import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

export const WebBookingReducre = createReducer({
  webbookingconfig: [],
  workflow: {},
}, {
  [types.GET_WEBBOOKING_PREFERENCE_START](state) {
    const newState = Object.assign({}, state, {
      getWebpreference: true,
    });

    return newState;
  },
  [types.GET_WEBBOOKING_PREFERENCE_FAIL](state) {
    const newState = Object.assign({}, state, {
      getWebpreference: false,
      webchatpreference: {},
    });

    return newState;
  },
  [types.GET_WEBBOOKING_PREFERENCE_SUCCESS](state, actions) {
    const newState = Object.assign({}, state, {
      getWebpreference: false,
      webchatpreference: actions.webchatpreference,
    });

    return newState;
  },
  [types.POST_WEBBOOKING_START](state) {
    const newState = Object.assign({}, state, {
      getWebpreference: true,
    });

    return newState;
  },
  [types.POST_WEBBOOKING_FAIL](state) {
    const newState = Object.assign({}, state, {
      getWebpreference: false,
      webchatpreference: {},
    });

    return newState;
  },
  [types.POST_WEBBOOKING_STATUS_SUCCESS](state, actions) {
    let temp = { ...state.webchatpreference };
    if (temp.booking_widget_status) {
      temp.booking_widget_status = actions.config;
    } else {
      temp.booking_widget_status = 'DISABLED';
    }
    const newState = Object.assign({}, state, {
      webchatpreference: temp,
    });

    return newState;
  },
  [types.POST_WEBBOOKING_SUCCESS](state, actions) {
    let temp = { ...state.webchatpreference };
    if (temp.booking_widget_personalization) {
      temp.booking_widget_personalization = actions.config;
    } else {
      temp.booking_widget_personalization = {};
      temp.booking_widget_personalization = actions.config;
    }
    const newState = Object.assign({}, state, {
      getWebpreference: false,
      webchatpreference: temp,
    });

    return newState;
  },
  [types.POST_WEBBOOKING_INSTRUCTION_SUCCESS](state, actions) {
    const newState = Object.assign({}, state, {
      getEmailInst: false,
      logoSizeerror: false,
      uploadFail: false,
    });

    return newState;
  },
  [types.POST_WEBBOOKING_INSTRUCTION_START](state, actions) {
    const newState = Object.assign({}, state, {
      getEmailInst: true,
      logoSizeerror: false,
      uploadFail: false,
    });

    return newState;
  },
  [types.POST_WEBBOOKING_INSTRUCTION_FAIL](state, actions) {
    const newState = Object.assign({}, state, {
      getEmailInst: false,
      logoSizeerror: false,
      uploadFail: false,
    });

    return newState;
  },
  [types.GET_WEBBOOKING_WORKFLOW_START](state, actions) {
    const newState = Object.assign({}, state, {
      getWorkflow: true,
      workflow: {},
    });

    return newState;
  },
  [types.GET_WEBBOOKING_WORKFLOW_SUCCESS](state, actions) {
    const newState = Object.assign({}, state, {
      getWorkflow: false,
      workflow: actions.worklfow,
    });

    return newState;
  },
  [types.GET_WEBBOOKING_WORKFLOW_FAIL](state) {
    const newState = Object.assign({}, state, {
      getWorkflow: false,
      workflow: {},
    });

    return newState;
  },
  [types.POST_WEBBOOKING_WORKFLOW_START](state, actions) {
    const newState = Object.assign({}, state, {
      postWorkflow: true,
      postWorkflowFail: false,
    });

    return newState;
  },
  [types.POST_WEBBOOKING_WORKFLOW_SUCCESS](state, actions) {
    const newState = Object.assign({}, state, {
      postWorkflow: false,
      postWorkflowFail: false,
    });

    return newState;
  },
  [types.POST_WEBBOOKING_WORKFLOW_FAIL](state) {
    const newState = Object.assign({}, state, {
      postWorkflow: false,
      postWorkflowFail: true,
    });

    return newState;
  },
});
export { WebBookingReducre as default };
